import chargerFourche from '@/assets/images/locations/RM_Charger/charger.png';
import chargerGuidon from '@/assets/images/locations/RM_Charger/charger_guidon.png';
import chargerBagage from '@/assets/images/locations/RM_Charger/charger_porte_bagage.png';
import chargerWheel from '@/assets/images/locations/RM_Charger/charger_roue.png';
import faceVadrouille from '@/assets/images/locations/asphalte/face.webp';
import faceChild from '@/assets/images/locations/child/face.png';
import galianBattery from '@/assets/images/locations/galian/battery.png';
import galianCargo from '@/assets/images/locations/galian/cargo.png';
import galianFront from '@/assets/images/locations/galian/front.png';
import galianFull from '@/assets/images/locations/galian/galian.png';
import galianMotor from '@/assets/images/locations/galian/motor.png';
import saddleVadrouille from '@/assets/images/locations/vadrouille/saddle.webp';
import vdvChain from '@/assets/images/locations/velo-de-ville/chain.png';
import vdvWheel from '@/assets/images/locations/velo-de-ville/delta_cruiser_plus.png';
import vdvRak from '@/assets/images/locations/velo-de-ville/rakvdv.png';
import vdvseat from '@/assets/images/locations/velo-de-ville/selle.png';
import bellecourChain from '@/assets/images/locations/voltaire/Copie_de_bellecour_26pouces_creme_panier_1-min-removebg-preview.png';
import bellecourCard from '@/assets/images/locations/voltaire/Panier_Voltaire.png';
import bellecourHandlebar from '@/assets/images/locations/voltaire/bellecour-handlebar.png';
import bellecourDisplay from '@/assets/images/locations/voltaire/display.png';
import bellecourBrake from '@/assets/images/locations/voltaire/frein_disk.png';
import A200Voyage from '@/assets/images/velos/a200_voyage.png';
import vdv from '@/assets/images/velos/a200_voyage.webp';
import asphalte from '@/assets/images/velos/asphalte_vadrouille.webp';
import aventure from '@/assets/images/velos/aventure.png';
import childBike from '@/assets/images/velos/child.png';
import vadrouille from '@/assets/images/velos/gravel_vadrouille.webp';
import type { BikeCharacteristicsType } from './bike-presentation-types';

export const chargerCharacteristisc: BikeCharacteristicsType[] = [
  {
    image: chargerFourche,
    text: 'fourche',
    alt: 'Charger fork',
    className: 'scale-x-[-1]',
  },
  {
    text: 'general',
    className: 'justify-evenly items-center',
  },
  {
    image: chargerBagage,
    text: 'bagage',
    alt: 'Charger bagage',
  },
  {
    image: chargerWheel,
    text: 'wheel',
    alt: 'Charger Wheel',
  },
  {
    image: chargerFourche,
    text: 'chain',
    alt: 'Charger fork',
  },
  {
    image: chargerGuidon,
    text: 'display',
    alt: 'Charger Handlebar ',
  },
];

export const voltaireCharacteristics: BikeCharacteristicsType[] = [
  {
    image: bellecourHandlebar,
    text: 'saddle',
    alt: 'Bellecour Bike',
    className: 'scale-x-[-1]',
  },
  {
    text: 'general',
    className: 'justify-evenly items-center',
  },
  {
    image: bellecourCard,
    text: 'card',
    alt: 'Bellecour Card',
  },
  {
    image: bellecourBrake,
    text: 'brake',
    alt: 'Bellecour Brake',
  },
  {
    image: bellecourChain,
    text: 'transmission',
    alt: 'Bellecour Engine',
  },
  {
    image: bellecourDisplay,
    text: 'display',
    alt: 'Bellecour Bike',
  },
];

export const vdvCharacteristics: BikeCharacteristicsType[] = [
  {
    image: vdv,
    text: 'fourche',
    alt: 'Velo de ville Bike',
    className: 'scale-x-[-1]',
  },
  {
    text: 'general',
    className: 'justify-evenly items-center',
  },
  {
    image: vdvseat,
    text: 'seat',
    alt: 'Velo de ville Bike Back',
  },
  {
    image: vdvRak,
    text: 'rake',
    alt: 'Velo de ville Bike Front',
  },
  {
    image: vdvChain,
    text: 'transmission',
    alt: 'Velo de ville Bike Front',
  },
  {
    image: vdvWheel,
    text: 'wheel',
    alt: 'Velo de ville Wheel',
  },
];

export const vdvA200Characteristics: BikeCharacteristicsType[] = [
  {
    image: A200Voyage,
    text: 'fourche',
    alt: 'Velo de ville Bike',
    className: 'scale-x-[-1]',
  },
  {
    text: 'general',
    className: 'justify-evenly items-center',
  },
  {
    image: vdvseat,
    text: 'seat',
    alt: 'Velo de ville Bike Back',
  },
  {
    image: vdvRak,
    text: 'rake',
    alt: 'Velo de ville Bike Front',
  },
  {
    image: vdvChain,
    text: 'transmission',
    alt: 'Velo de ville Bike Front',
  },
  {
    image: vdvWheel,
    text: 'wheel',
    alt: 'Velo de ville Wheel',
  },
];

export const galianCharacteristics: BikeCharacteristicsType[] = [
  {
    image: galianFull,
    text: 'vitesse',
    alt: 'Velo de cargo Galian',
    className: 'items-center',
  },
  {
    text: 'general',
    className: 'justify-evenly items-center',
  },
  {
    image: galianBattery,
    text: 'seat',
    alt: 'Velo de cargo Back',
  },
  {
    image: galianCargo,
    text: 'bagage',
    alt: 'Velo de cargo Front',
  },
  {
    image: galianFront,
    text: 'transmission',
    alt: 'Velo de cargo Front',
  },
  {
    image: galianMotor,
    text: 'wheel',
    alt: 'Velo de cargo Wheel',
  },
];

export const vadrouilleCharacteristics: BikeCharacteristicsType[] = [
  {
    image: vadrouille,
    text: 'cadre',
    alt: 'cadre velo gravel',
    className: 'items-center',
  },
  {
    text: 'general',
    className: 'justify-evenly items-center',
  },
  {
    image: saddleVadrouille,
    text: 'seat',
    alt: 'Selle velo',
  },
];
export const asphalteCharacteristics: BikeCharacteristicsType[] = [
  {
    image: asphalte,
    text: 'cadre',
    alt: 'cadre velo route',
    className: 'items-center',
  },
  {
    text: 'general',
    className: 'justify-evenly items-center',
  },
  {
    image: faceVadrouille,
    text: 'seat',
    alt: 'Face de velo',
  },
];

export const adventureCharacteristics: BikeCharacteristicsType[] = [
  {
    image: aventure,
    text: 'cadre',
    alt: 'cadre velo route',
    className: 'items-center',
  },
  {
    text: 'general',
    className: 'justify-evenly items-center',
  },
  {
    image: faceVadrouille,
    text: 'seat',
    alt: 'Face de velo',
  },
];

export const childBikeCharacteristics: BikeCharacteristicsType[] = [
  {
    image: faceChild,
    text: 'cadre',
    alt: 'cadre velo route',
    className: 'items-center',
  },
  {
    text: 'general',
    className: 'justify-evenly items-center',
  },
  {
    image: childBike,
    text: 'seat',
    alt: 'Face de velo',
  },
];
